import React, { FC } from 'react';
import { ButtonStroke } from '@blink/components';
import { ReactComponent as ClockIcon } from '@blink/assets/src/icons/clock.svg';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowIcon } from '@blink/assets/src/icons/arrowBtn.svg';
import { useSelector } from 'react-redux';

import { useAssetsToLendSectionStyle } from './AssetsToLendSection.style';
import { PATHS } from 'src/routes/paths';
import { AssetsToLendItemRow } from './AssetToLendItmRow';

import { Store } from '@/shared/store';
import { Vault } from '@/shared/api/vault';
import { ROLE } from '@/shared/api/borrow';
import { EmptyBanner } from '@/widgets/Banners/EmptyBanner';

type AssetsToLendVaultSection = {
    vault: Vault;
};

export const AssetsToLendVaultSection: FC<AssetsToLendVaultSection> = ({ vault }) => {
    const classes = useAssetsToLendSectionStyle();
    const navigate = useNavigate();

    const { vaultLinkedPools } = useSelector((state: Store) => ({
        vaultLinkedPools: state.vaults.linkedPools,
    }));

    const linkedPools = vaultLinkedPools[vault?.address];

    const getContent = () => {
        const indexes = [];

        for (const [i] of linkedPools.entries()) {
            indexes.push(i);
        }

        return indexes.map((index) => (
            <AssetsToLendItemRow
                key={index}
                itemIndex={index}
                allItems={linkedPools}
                vault={vault}
                role={ROLE.LENDER}
            />
        ));
    };

    const handleClick = () => {
        navigate(PATHS.POOL_PERSONALISED, { state: { referrer: location.pathname } });
    };

    return (
        <div className='w-full text-primary mt-[52px]'>
            <div className={classes.header}>
                <div className='text-lg pb-6 pl-6'>{'Assets to Supply'}</div>
                <div className={classes.container}>
                    <span className={classes.text}>We provide personalised pools upon request</span>
                    <ButtonStroke
                        className={classes.poolBtn}
                        isOutline={true}
                        onClick={handleClick}
                    >
                        <ArrowIcon />
                        Request personalised pool
                    </ButtonStroke>
                </div>
            </div>
            {!linkedPools ? (
                <div>
                    <EmptyBanner
                        customTitle={'You don’t have any whitelisted pools yet.'}
                        customSubtitle={
                            'Please check back later or contact support if you need help with accessing pools.'
                        }
                        icon={ClockIcon}
                    />
                </div>
            ) : (
                <div className='flex items-center'>
                    <table className='border-collapse w-full bg-primary border border-opaque min-w-[820px]'>
                        <thead>
                            <tr
                                className='
                                            border-b border-opaque h-[52px] 
                                            [&_span]:font-medium 
                                            [&>th]:font-normal [&>th]:text-left [&>th]:text-primary [&>th]:w-[20%] [&>th]:bg-background-secondary 
                                            [&>th:last-child]:text-right 
                                            [&>td:last-child]:pr-7 [&>th:last-child]:pr-7 
                                            [&>td:first-child]:pl-6 [&>th:first-child]:pl-6'
                            >
                                <th className={classes.asset}>Pool</th>
                                <th className={classes.asset}>Asset</th>
                                <th className={classes.totalSupplyWrapper}>Total Supply</th>
                                <th>
                                    <div>
                                        <span>{`Supply APY`}</span>{' '}
                                    </div>
                                </th>
                                <th>Your Wallet</th>
                                <th className={classes.buttons} />
                            </tr>
                        </thead>
                        <tbody>{getContent()}</tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
